export default __webpack_public_path__ + "static/media/us-ca.745c1c9e.svg";